// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27c_A","close":"styles_close__1ra69","card":"styles_card__1xmSV","head":"styles_head__3Hfvl","body":"styles_body__2SDNT"};